module.exports = __webpack_public_path__ + "img/11.ecc34b16.png";